import get from 'lodash/get';

export default function getMokaUserId(state) {
  return get(state, ['moka', 'user', 'id']);
}
